import { render } from "./sliderComponent.vue?vue&type=template&id=2e1ec6c6"
import script from "./sliderComponent.vue?vue&type=script&lang=js"
export * from "./sliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__